"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Button, IconButtonV2 } from "@nxt-costco-com/forge-components";
import { ColorBlue500, SpaceXxs, ColorGray700, ColorBlue700 } from "@nxt-costco-com/forge-design-tokens";
import { Heart } from "@nxt-costco-com/forge-icons/icons/Heart";
import { ShoppingList } from "@nxt-costco-com/forge-icons/icons/ShoppingList";
import { BUTTON_COMPONENT_NAME } from "../constants.js";
const AddToListButton = ({
  buttonLabel = "",
  buttonSize = "medium",
  handleClick,
  uniqueId = "",
  variant = "icon",
  ariaDescribedBy,
  sx = []
}) => {
  if (variant === "textWithIcon") {
    return /* @__PURE__ */ jsxs(
      Button,
      {
        "aria-describedby": ariaDescribedBy,
        "data-testid": `${BUTTON_COMPONENT_NAME}${uniqueId}`,
        onClick: handleClick,
        sx,
        variant: "ghost",
        children: [
          /* @__PURE__ */ jsx(
            ShoppingList,
            {
              sx: {
                mr: SpaceXxs
              },
              color: ColorBlue500,
              height: 22,
              width: 22
            }
          ),
          buttonLabel
        ]
      }
    );
  }
  if (variant === "iconV2") {
    return /* @__PURE__ */ jsx(
      IconButtonV2,
      {
        "aria-label": ariaDescribedBy ? ariaDescribedBy : buttonLabel,
        onClick: handleClick,
        size: buttonSize,
        sx: [...Array.isArray(sx) ? sx : [sx]],
        title: buttonLabel,
        type: "contained",
        uniqueId: `${BUTTON_COMPONENT_NAME}${uniqueId}`,
        children: /* @__PURE__ */ jsx(Heart, { sx: { color: ColorGray700 } })
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Button,
    {
      sx: [
        {
          height: "24px",
          minWidth: "24px",
          padding: 0
        },
        ...Array.isArray(sx) ? sx : [sx]
      ],
      "aria-describedby": ariaDescribedBy,
      "aria-label": buttonLabel,
      "data-testid": `${BUTTON_COMPONENT_NAME}${uniqueId}`,
      onClick: handleClick,
      variant: "tertiary",
      children: /* @__PURE__ */ jsx(ShoppingList, { color: ColorBlue700, height: 24, width: 24 })
    }
  );
};
AddToListButton.displayName = BUTTON_COMPONENT_NAME;
export {
  AddToListButton
};
